<template>
  <div class="col-12 col-xl-9 mt-3 mt-md-0">
    <router-view></router-view>
  </div>
</template>

<script>
import _GlobalHelper from "@/store/helpers/global";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "tours",
  methods: {
    ...mapMutations({
      setAlertOptions: _GlobalHelper.mutations.setAlertOptions,
    }),

    clearAlert() {
      this.setAlertOptions({
        show: false,
        title: null,
        message: null,
        type: null,
        continue: false,
        confirm_label: null,
        cancel_label: null,
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name.indexOf("tours") === -1) {
      next();
      return;
    }

    this.setAlertOptions({
      show: true,
      title: "¿Desea abandonar su compra?",
      message: "Al aceptar automaticamente se perderá el/los tour(s) seleccionados.",
      cancel_label: "ABANDONAR COMPRA",
      confirm_label: "CONTINUAR COMPRA",
      leave: () => {
        this.$cookies.remove("shopping-booking");
        this.$cookies.remove("shopping");
        this.clearAlert();
        next();
      },
      accept: () => {
        this.clearAlert();
      },
    });

    next(false);
  },
};
</script>